/**
 * Validates the birth date. Checks if it's between the specific age range.
 * It should not produce an error but a warning if the age is not within the range.
 * @param value The value to validate.
 */
import { WritableSignal } from '@angular/core';

export function validateBirthDateAndSetWarning(
	value: unknown,
	showWarning: WritableSignal<boolean>,
	range = { min: 13, max: 67 },
) {
	if (!value) {
		showWarning.set(false);
		return;
	}

	const dateOfBirth = value as string;

	// Check if person is between 13 and 67 years old.
	// If not, set birthdayWarning to true.
	const today = new Date();
	const birthDate = new Date(dateOfBirth);
	const age = today.getFullYear() - birthDate.getFullYear();

	if (age < range.min || age > range.max) {
		showWarning.set(true);
	} else {
		showWarning.set(false);
	}
}
